import React, { FunctionComponent } from "react";
import { useEffect, useState } from "react";

export type PageNumbersProps = {
  perPage: number;
  page: number;
  totalRecords: number;
  setPage: (page: number) => void;
  theme?: "light" | "dark";
};

const PageNumbers: FunctionComponent<PageNumbersProps> = ({
  perPage = 10,
  page = 1,
  totalRecords,
  setPage,
  theme = "light",
}) => {
  const [pageInput, setPageInput] = useState<string>(page.toString());
  const numPages = Math.ceil(totalRecords / perPage);

  useEffect(() => {
    if (page.toString() !== pageInput) {
      setPageInput(page.toString());
    }
  }, [page]);

  const updatePage = (e: React.FormEvent) => {
    e.preventDefault();
    const newPage = parseInt(pageInput, 10);
    if (pageInput !== page.toString() && newPage <= numPages) {
      setPage(newPage);
    }
  };

  return (
    <form className="page-numbers" onSubmit={updatePage}>
      {page > 1 && (
        <button
          className="prev-page"
          onClick={() => setPage(page - 1)}
          type="button"
        >
          {"< Prev"}
        </button>
      )}
      Page
      <input
        className="page-input"
        onBlur={updatePage}
        onChange={(e) => setPageInput(e.target.value)}
        maxLength={numPages.toString().length}
        size={pageInput.length || 1}
        type="text"
        value={pageInput}
      />
      of
      <button
        className={"page-num"}
        onClick={() => setPage(numPages)}
        key={numPages}
        type="button"
        disabled={numPages === page}
      >
        {numPages}
      </button>
      {numPages > page && (
        <button
          className="next-page"
          onClick={() => setPage(page + 1)}
          type="button"
        >
          {"Next >"}
        </button>
      )}
      <style jsx>{`
        .page-numbers {
          width: 100%;
          font-size: 0.85rem;
          font-family: Inter, Helvetica, sans-serif;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
        }

        .page-input {
          border-bottom: 1px solid #dbe0e3;
          border-top: 1px solid transparent;
          text-align: center;
          padding: 2px 2px;
        }

        .page-num {
          border: none;
          background: none;
          color: ${theme === "light" ? "#1b1d24" : "white"};
          padding: 6px;
        }

        .page-num.active {
          text-decoration: underline;
          font-weight: bold;
        }

        .next-page,
        .prev-page {
          border: none;
          background: none;
          color: #2482ff;
          font-weight: 600;
          padding: 0;
        }

        .prev-page {
          margin: 0 15px 0 0;
        }

        .next-page {
          margin: 0 0 0 10px;
        }

        .page-num:not(:disabled):hover {
          color: #2482ff;
        }

        @media (max-width: 420px) {
          .page-num {
            margin: 2px;
          }
        }
      `}</style>
    </form>
  );
};

export default PageNumbers;
